/* ---- Core ---- */
import { onUnmounted, readonly, ref, watch, type Ref } from 'vue';

export function useSmsTimer(isActive: Ref<boolean>): unknown {
  /* ---- State ---- */
  const time = ref(59);
  let timer: NodeJS.Timer;

  /* ---- Hooks ---- */
  onUnmounted(() => {
    clearInterval(timer as unknown as number);
  });

  /* ---- Watchers ---- */

  const setTimer = (isActive: boolean) => {
    clearInterval(timer as unknown as number);
    time.value = 59;
    if (isActive) {
      timer = setInterval(() => {
        if (time.value > 0) {
          time.value = time.value - 1;
        } else {
          clearInterval(timer as unknown as number);
        }
      }, 1000);
    }
  };

  setTimer(isActive.value);
  watch(isActive, (newIsActive) => {
    setTimer(newIsActive);
  });

  /* ---- return reactive value of composable ---- */
  return { resetTimer: setTimer, time: readonly(time) };
}
